
import { useState } from "react"
import { addressToString, fetchEvent, formatAddress } from "../utils/functions";


export default function useApp(urlHash: string) {
  const [code, setCode] = useState('')

  const [showComponent, setShowComponent] = useState(1); // 1 - login, 2 - form, 3 - success
  const [showErrorBox, setShowErrorBox] = useState(false)
  const [errorMessage, setErrorMessage] = useState('El código o la dirección del enlace no es válido.')

  const [updatingAddress, setUpdatingAddress] = useState(false)
  const [addressString, setAddressString] = useState('')
  const [address, setAddress] = useState<Address | null>(null)
  const [carrier, setCarrier] = useState('')
  const [trackingCode, setTrackingCode] = useState('')
  const [brand, setBrand] = useState<Brand>({})

  const [loadingCode, setLoadingCode] = useState(false);
  const validateCode = async (code: string) => {
    setLoadingCode(true)
    setShowErrorBox(false)
    setCode(code)
    try {
      const body = {
        "resource": "get_wrong_address",
        "country_code": process.env.REACT_APP_COUNTRY,
        "body": {
          "uri": urlHash,
          "code": code,
        },
      }
      const res = await fetchEvent(body)

      if (res.status_codes === 200) {
        setAddressString(addressToString(res.data.wrong_user_address_data))
        const formattedAddress: Address = formatAddress(res.data.wrong_user_address_data)
        setAddress(formattedAddress)
        setTrackingCode(res.data.wrong_user_address_data.trackingCode)
        // setCarrier(findCountryName(res.data.wrong_user_address_data.idCarrier))
        setCarrier(res.data.wrong_user_address_data.carrier)
        const brand = res.data.user_brand
        if (brand) {
          setBrand({
            brandLogo: brand.logo?.replace(/\/$/, ''),
            brandColor: brand.color,
            brandUrl: brand.website,
            brandName: brand.name
          })
        }
        setLoadingCode(false)
        setShowComponent(2)
      } else {
        console.error(res)
        setShowErrorBox(true)
        setLoadingCode(false)
      }
    } catch (error) {
      console.error(error)
      setShowErrorBox(true)
      setLoadingCode(false)
    }
  }

  const updateAddress = async (modAddress: Address) => {
    setUpdatingAddress(true)
    try {
      const body = {
        "resource": "store_correct_address",
        "country_code": process.env.REACT_APP_COUNTRY,
        "body": {
          "event_type": "wrong_address",
          "uri": urlHash,
          "code": code,
          "addresseeAddress1": modAddress.street,
          "addresseeNumber": modAddress.number,
          "addresseeIntNumber": modAddress.intNumber,
          "addresseeColonia": modAddress.suburb,
          "addresseeCrossStreet": modAddress.crossStreet,
          "addresseeReference": modAddress.reference,
          "addresseeObservations": modAddress.observations,
          "addresseeZip": modAddress.zipCode,
          "addresseeLat": address!.addresseeLat,
          "addresseeLng": address!.addresseeLng,
          "addresseePhone": modAddress.addresseePhone,
        }
      }
      const res = await fetchEvent(body)
      if (res.status_codes === 200) {
        setUpdatingAddress(false)
        setShowComponent(3)
      } else {
        console.error(res)
        setErrorMessage('No se pudo actulizar la dirección')
        setShowErrorBox(true)
        setUpdatingAddress(false)
      }
    } catch (error) {
      console.error(error)
      setErrorMessage('No se pudo actulizar la dirección')
      setShowErrorBox(true)
      setUpdatingAddress(false)
    }
  }

  return {
    code,
    showComponent,
    showErrorBox,
    errorMessage,
    updatingAddress,
    address,
    carrier,
    trackingCode,
    brand,
    loadingCode,
    validateCode,
    setCode,
    updateAddress,
    addressString
  }
}